module.exports = __webpack_public_path__ + "static/media/mkb_logo.8ce4dd1f.png";